import React from 'react';
import { Block, ListBasic, ListItemWithImage, AvatarImage, Text } from '@hz-design-system/web-ui';
import imageSizeFormatter from '../../../utils/imageSizeFormatter';
import { ImageSize } from '@ecg-marktplaats/media-util-js-lib';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import Classes from '../ProfileSidebar.scss';

const { Regular } = Text;

const SalesRepresentativesBlock = ({ salesRepresentatives }: { salesRepresentatives: any[] }) => {
  const i18n = useI18nContext();
  const formattedUrl = (url: string) => imageSizeFormatter({ imageUrlFromApi: url, customSize: ImageSize.Medium });

  if (!salesRepresentatives.length) {
    return null;
  }

  return (
    <Block className={Classes.salesRepsSection}>
      <ListBasic title={i18n.t('sellerProfile.salesRepsTitle')}>
        {salesRepresentatives.map((rep, index) => (
          <ListItemWithImage
            key={`list-item-${index}`}
            image={<AvatarImage src={formattedUrl(rep.photo?.base)} alt="image" placeholderIconName="profile" />}
          >
            <Regular color="TextPrimary">{rep.name}</Regular>
            <Regular color="TextTertiary">{rep.title}</Regular>
          </ListItemWithImage>
        ))}
      </ListBasic>
    </Block>
  );
};

export default SalesRepresentativesBlock;
